import React, { useId, useState } from "react";
import "../../styles/MerchantModeSelector.css";

const MODES = [
  {
    id: "delivery",
    label: "Delivery",
    description: "Pedidos para enviar o retirar. Sin mesas ni mozos; stock opcional.",
  },
  {
    id: "restaurant",
    label: "Restaurante",
    description: "Mesas con QR, equipo de mozos y delivery en un mismo comercio.",
  },
  {
    id: "kiosk",
    label: "Kiosk",
    description: "Totems, autoservicio, pago y numero de preparacion.",
  },
];

function MerchantModeSelector({ value, onChange, disabled = false, children }) {
  const id = useId();
  const [advancedOpen, setAdvancedOpen] = useState(value === "kiosk");

  const renderOption = (option) => {
    const selected = value === option.id;
    const descriptionId = `${id}-${option.id}-description`;

    return (
      <label key={option.id} className="merchant-mode__option" data-selected={selected}>
        <input
          type="radio"
          name={`${id}-mode`}
          value={option.id}
          checked={selected}
          aria-checked={selected}
          aria-label={option.label}
          aria-describedby={descriptionId}
          disabled={disabled}
          onChange={() => onChange(option.id)}
        />
        <span className="merchant-mode__copy">
          <strong>{option.label}</strong>
          <span id={descriptionId}>{option.description}</span>
          <small aria-hidden="true">{selected ? "Seleccionado" : "Elegir modalidad"}</small>
        </span>
      </label>
    );
  };

  return (
    <fieldset className="merchant-mode" disabled={disabled}>
      <legend>Como queres trabajar?</legend>
      <div className="merchant-mode__choices">{MODES.slice(0, 2).map(renderOption)}</div>
      <p className="merchant-mode__hint">
        Empeza con lo que necesitas. Las herramientas adicionales son opcionales.
      </p>
      <button
        type="button"
        className="merchant-mode__advanced-toggle"
        aria-expanded={advancedOpen}
        aria-controls={`${id}-advanced`}
        onClick={() => setAdvancedOpen((open) => !open)}
        disabled={disabled}
      >
        Opciones avanzadas: herramientas y kiosk
      </button>
      <div id={`${id}-advanced`} className="merchant-mode__advanced" hidden={!advancedOpen}>
        {renderOption(MODES[2])}
        <p className="merchant-mode__hint">
          Kiosk conserva su modalidad fija. Para cambiar entre kiosk y restaurante,
          crea otra sucursal.
        </p>
        {children}
      </div>
    </fieldset>
  );
}

export default MerchantModeSelector;
